import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	// list: (params, successCallback, failCallback, exceptionCallback) => {
	// 	ApiUtils.getLoadingAjax(constant.serverUrl + "/product/sprint/list", params, successCallback, failCallback, exceptionCallback);
	// },
	list2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/product/sprint/list", params, successCallback, failCallback, exceptionCallback);
	},
	listUnTeamed: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/product/sprint/listUnTeamed", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/product/sprint/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/product/sprint/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/product/sprint/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/product/sprint/remove", params, successCallback, failCallback, exceptionCallback);
	},
	getSprintsByProId: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/product/sprint/getSprintsByProId", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
